<template>
  <div v-if="visible" data-test="painel-composicao-licencas">
    <Panel lineColor="var(--primary-color)" class="text-start mb-5">
      <v-row no-gutters>
        <div>
          <h4>Composição de Licenças</h4>
          <p class="mb-0 caption grey--text text--darken-1">
            Valores da competência {{ competenciaLabel }}
          </p>
        </div>
        <v-icon class="ml-auto" v-if="showPanel" @click="showPanel = false">
          fa-chevron-up
        </v-icon>
        <v-icon class="ml-auto" v-else @click="showPanel = true">
          fa-chevron-down
        </v-icon>
      </v-row>
      <template v-if="showPanel">
        <LineDivider />
        <v-row>
          <v-col
            v-for="licenca in licencas"
            :key="licenca.produto"
            cols="12"
            md="6"
          >
            <v-card outlined class="licenca-card">
              <v-card-title class="subtitle-1 font-weight-bold py-3">
                {{ labelProdutoLicenca(licenca.produto) }}
              </v-card-title>
              <v-card-text>
                <p class="overline mb-2">Cobrança</p>
                <v-simple-table dense class="licenca-cobranca-table">
                  <tbody>
                    <tr>
                      <td>Licenças contratadas</td>
                      <td class="text-right font-weight-medium">
                        {{ licenca.quantidade_licencas_contratadas }}
                      </td>
                    </tr>
                    <tr>
                      <td>Valor unitário da licença</td>
                      <td class="text-right font-weight-medium">
                        {{ licenca.valor_unitario_licenca | formatMoney }}
                      </td>
                    </tr>
                    <tr>
                      <td>Valor cobrado de licenças</td>
                      <td class="text-right font-weight-medium">
                        {{ licenca.valor_cobrado_licencas | formatMoney }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div
                  class="licenca-ativos-bloco mt-4"
                  data-test="bloco-usuarios-ativos"
                >
                  <p class="overline mb-1">Informativo</p>
                  <p class="mb-1 body-2 font-weight-medium">
                    Usuários ativos
                  </p>
                  <p class="mb-2 caption">
                    Este número não altera o valor cobrado. É apenas
                    informativo.
                  </p>
                  <p
                    class="mb-0 headline"
                    :class="{
                      'grey--text': isUsuariosAtivosIndisponivel(
                        licenca.usuariosAtivosNoMomento
                      )
                    }"
                    data-test="valor-usuarios-ativos"
                  >
                    {{ formatUsuariosAtivos(licenca.usuariosAtivosNoMomento) }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import LineDivider from "@/components/LineDivider";
import {
  formatCompetenciaLabel,
  formatUsuariosAtivos,
  hasLicencasPanel,
  isUsuariosAtivosIndisponivel,
  labelProdutoLicenca
} from "../licencas-helpers";

export default {
  name: "ValorServicoLicencas",
  components: {
    Panel,
    LineDivider
  },
  props: {
    licencas: {
      type: Array,
      default: () => []
    },
    competencia: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    showPanel: true
  }),
  computed: {
    visible() {
      return hasLicencasPanel(this.licencas);
    },
    competenciaLabel() {
      return formatCompetenciaLabel(this.competencia);
    }
  },
  methods: {
    labelProdutoLicenca,
    formatUsuariosAtivos,
    isUsuariosAtivosIndisponivel
  }
};
</script>

<style scoped>
.licenca-ativos-bloco {
  background: #f4f6f8;
  border-left: 4px solid #9e9e9e;
  padding: 12px 16px;
  border-radius: 4px;
}
.licenca-cobranca-table td {
  height: 40px;
}
</style>
